<my-header></my-header>
<app-error-popup [show]="showErrorPopup" [errorMessage]="currentErrorMessage" (close)="onCloseErrorPopup()"></app-error-popup>
<div class="history">
    <app-banner></app-banner>
    <div class="bread-crumbs" #breadcrumbs>
          <button class="new" [class.active]="activeSection === 'newPrescription'" (click)="showSection('newPrescription')">
            New eRx(s) <span>{{dboardCounts.New_Prescription}}</span>
        </button>
          <button class="refills" [class.active]="activeSection === 'refillsDue'" (click)="showSection('refillsDue')">
            Refills Due <span>{{dboardCounts.Refills_Due }}</span>
        </button>
                <button class="meds" [class.active]="activeSection === 'myMeds'" (click)="showSection('myMeds')">
            My Meds <span>{{ dboardCounts.My_Meds }}</span>
        </button>
        <button class="pending" [class.active]="activeSection === 'pendingPayments'" (click)="showSection('pendingPayments')">
            Pending Orders <span>{{dboardCounts.Pending_Payments}}</span>
        </button>
        <button class="ready" [class.active]="activeSection === 'readyToDispense'" (click)="showSection('readyToDispense')">
            Rx(s) Ready <span>{{dboardCounts.Ready_to_Dispense }}</span>
        </button>
      
      
    </div>
    <div class="history-data" [ngSwitch]="activeSection" #historyData>
        <!-- pendingPayments section start -->
        <div *ngSwitchCase="'pendingPayments'">
            <div class="pending-payments mobile-common-scroll" #pendingPaymentsDivs *ngIf="!noDataFound"> 
                <div class="title mobile-common-title">
                    <span>Total Pending Orders Count: {{transcationCount}}</span>
                    <span class="dispenseMenu"></span>
                </div>
                <div class="item mymeds" #item *ngFor="let item of transcationList;let i = index;" [class.active]="i === 0">
                    <div class="label" (click)="toggleAccordion(item, i)">
                        <div class="meds meds-1">
                            <span>Transaction#</span>
                            <span>{{item?.transID}}</span>
                        </div>
                        <div class="meds meds-2">
                            <span>Msg. Recvd. Dt Tm</span>
                            <span>{{item?.transDate | dateTimeUtcPipe:'date'}} <span class="text-small">{{item?.transDate | date: "hh:mm a"}}</span></span>
                        </div>
                        <div class="meds meds-3">
                            <span>No. of Items </span>
                            <span>{{item?.salesDetailsList?.length}}</span>
                        </div>
                        <div class="meds meds-4">
                            <span>Amount</span>
                            <span class="pending-amt">{{item?.amount ? (item?.amount | currency) : "$0.00"}}</span>
                        </div>
                        <div class="meds meds-5">
                            <button type="button" class="btn-pending" (click)="goToReviewOrder(item)">Checkout</button>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="noDataFound" class="nodataTxt">{{noData_Msg}}</div>
        </div>
        <!-- pendingPayments section end -->

        <!-- My Meds section start -->
         <div class="" *ngSwitchCase="'myMeds'">
            <div class="hist-switch mobile-common-scroll" #heightMyMeds>
                <!-- Summary Section for Mobile View -->
                <div class="summary-section mobile-only" [class.hidden]="currentSection">
                    <div class="summary-item" (click)="toggleSection('activeMeds')">
                        <span>Active Meds: {{ customRxHistory[0]?.eachLength ?? 0 }}</span>
                        <span class="material-symbols-outlined arrow" [class.active]="currentSection === 'activeMeds'">chevron_right</span>
                    </div>
                    <div class="summary-item" (click)="toggleSection('history')">
                        <span>History: {{ customRxHistory[1]?.eachLength ?? 0 }}</span>
                        <span class="material-symbols-outlined arrow" [class.active]="currentSection === 'history'">chevron_right</span>
                    </div>
                </div>

                <!-- Detailed Section (shown when a section is expanded) -->
                <div class="details-section" [class.hidden]="!currentSection">
                    <div class="sticky-header" #stickyHeader>
                        <span class="title"><span class="material-symbols-outlined icon_size left_arrow" (click)="goToPreviousScreen()">arrow_back</span>{{stickyHeaderText}}</span>
                        <span class="filterMenu" (click)="togglePopup()" #filterIcon>Filter</span>
                    </div>
                    <div *ngFor="let header of customRxHistory; let i = index;" class="section sec{{i}}" data-section-index="i">
                        <div class="title" *ngIf="'sec' + i !== 'sec0'">
                            <span>{{header.Section}}: {{header.eachLength}}</span>
                        </div>
                        <div class="item mymeds" #item *ngFor="let item of header.records; let j = index;" [class.active]="item.index === activeIndex">
                            <div class="label" (click)="toggleAccordion(item, item.index)" *ngIf="!item?.isExternalPrescription">
                                <div class="meds meds-1">
                                    <span>Rx#</span>
                                   <span>{{item?.RxDisplay}}</span>
                                </div>
                                <div class="meds meds-2">
                                    <span>Fill Date</span>
                                    <span>{{item?.Fill_Date | dateTimeUtcPipe:'date'}}</span>
                                </div>
                                <div class="meds meds-3">
                                    <span>Drug Name</span>
                                    <span class="drug_name">{{item?.Drug_Name | titlecase}}</span>
                                </div>
                                <div class="meds meds-4">
                                    <span>Qty / Days Supply</span>
                                    <span>{{item?.Qty}} / {{item?.Days_Supply}}</span>
                                </div>
                                <div class="meds meds-5">
                                    <span>Rx Status</span>
                                    <span>{{item?.Rx_Status}}</span>
                                </div>
                                <div class="meds meds-6">
                                    <span>Prescriber Name</span>
                                    <span>{{item?.Prescriber_name | titlecase}}</span>
                                </div>
                                <div class="meds meds-7">
                                    <span>Insurance (BIN# / PCN#)</span>
                                    <span>{{item?.Insurance}}</span>
                                </div>
                                <div class="meds meds-8">
                                    <span>{{ item?.isCash ? 'Pat. Pay' : 'Copay Amt' }}</span>
                                    <span>{{item?.Cpay_Amt ? (item?.Cpay_Amt | currency) : "$0.00"}}</span>
                                </div>
                            </div>
                            <div class="label_extern" (click)="toggleAccordion(item, item.index)" *ngIf="item?.isExternalPrescription">
                                <div class="meds meds-1">
                                    <div class="pharmacy_name" [title] ="item?.Source_PharmacyName ? item?.Source_PharmacyName : ''">{{item?.Source_PharmacyName ? (item?.Source_PharmacyName | titlecase): '--'}}</div>
                                    <span class="action_icons_desktop">
                                    <span class="material-symbols-outlined font_size_21px desktop_only color_gray" (click)="editExternalMeds(item, item?.index); $event.stopPropagation()">edit</span>
                                        <span class="material-symbols-outlined font_size_21px desktop_only color_gray" (click)="deleteExternalMeds(item, item?.externalHistoryId); $event.stopPropagation()">delete</span>
                                    </span>
                                </div>
                                <div class="meds meds-2">
                                    <span>Rx#</span>
                                    <span>{{item?.Rx ? item?.Rx : '--'}}</span>
                                </div>
                                <div class="meds meds-3">
                                    <span>Ordered Date</span>
                                    <span>{{item?.Order_Date ? (item?.Order_Date | dateTimeUtcPipe:'date') : '--'}}</span>
                                </div>
                                <div class="meds meds-4">
                                    <span>Drug Name</span>
                                    <span class="drug_name">{{item?.Drug_Name ? (item?.Drug_Name | titlecase) : '--'}}</span>
                                </div>
                                <div class="meds meds-5">
                                    <span>Refills Left / Days Supply</span>
                                    <span>
                                        {{item?.Refil_Left ? item?.Refil_Left : '--'}} / 
                                        {{item?.Days_Supply ? item?.Days_Supply : '--'}}
                                    </span>
                                </div>
                                <div class="meds meds-6">
                                    <span>Days Supply</span>
                                    <span>{{item?.Days_Supply ? item?.Days_Supply : '--'}}</span>
                                </div>
                                <div class="meds meds-7">
                                    <span>Fill Date</span>
                                    <span>{{item?.Fill_Date | dateTimeUtcPipe:'date'}}</span>
                                </div>
                                <div class="meds meds-8">
                                    <!-- <span>Expiration Date</span> -->
                                      <span class="label-full">Expiration Date</span>
                                    <span class="label-short">Exp Date</span>
                                    <span>{{item?.Expiration_Date ? (item?.Expiration_Date | dateTimeUtcPipe:'date') : '--'}}</span>
                                </div>
                                <div class="meds meds-9">
                                    <span class="label-full">Pharmacy Phone#</span>
                                    <span class="label-short">Pharm Ph#</span>
                                    <span>{{item?.Source_Pharmacy_PhoneNumber ? (item?.Source_Pharmacy_PhoneNumber | pharmNumberformat) : '--'}}</span>
                                </div>
                                <div class="meds meds-10" (click)="$event.stopPropagation()">
                                    <span>Notes</span>
                                    <span class="notes-text" [class.expanded]="item.notesExpanded" (click)="item.Notes && item.Notes.length > 0 ? item.notesExpanded = !item.notesExpanded : null">{{item?.Notes ? item?.Notes : '--'}}</span>
                                </div>
                                <div class="meds meds-11">
                                    <div class="action_icons">
                                        <button class="action_buttons mobile_only" (click)="editExternalMeds(item, item?.index); $event.stopPropagation()"><span class="material-symbols-outlined icon_size">edit</span>Edit</button>
                                        <button class="action_buttons mobile_only" (click)="deleteExternalMeds(item, item?.externalHistoryId); $event.stopPropagation()"><span class="material-symbols-outlined icon_size" >delete</span>Delete</button>
                                        <button class="transfer_Rx" *ngIf="!item?.isTransferRequestSentFromMyPrimeRx" (click)="transferInExternMeds(item)">Transfer My Rx</button>
                                        <div class="tr_sent_success" *ngIf="item?.isTransferRequestSentFromMyPrimeRx"><span class="material-symbols-outlined font_size_21px">send</span>T-Req Sent</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Filter Popup (unchanged) -->
                <div class="backdrop" #backdrop></div>
                <div *ngIf="noDataFound" class="nodataTxt">{{noData_Msg}}</div>
                <div class="filter-container" #filterMenu>
                    <div class="filter-group custom-dropdown date-dropdown">
                        <input type="checkbox" id="date-range-dropdown-toggle" />
                        <label for="date-range-dropdown-toggle" (click)="toggleDateDropdown($event)" class="dropdown-button" id="date-range" #dateRange>{{ selDateOption }}</label>
                        <ul id="date-range" class="dropdown-menu" *ngIf="isDateDropdownOpen" (click)="$event.stopPropagation()">
                            <li *ngFor="let option of dateOptions" (click)="selectDateOption(option, $event)">
                                {{ option }}
                            </li>
                        </ul>
                        <label for="date-range">By Date Range</label>
                        <div *ngIf="selDateOption === 'Custom Date'" class="custom_date">
                            <input
                                class="form-control cust-date"
                                ngbDatepicker
                                name="fromDatepicker"
                                #fromDatepicker="ngbDatepicker"
                                #fromDateInput
                                (click)="onInputClick(fromDatepicker)"
                                (dateSelect)="onDateSelect($event, fromDatepicker)"
                            />
                            <label>From Date:</label>
                            <input
                                class="form-control cust-date"
                                ngbDatepicker
                                name="toDatepicker"
                                #toDatepicker="ngbDatepicker"
                                #toDateInput
                                (click)="onInputClick(toDatepicker)"
                                (dateSelect)="onDateSelect($event, toDatepicker)"
                            />
                            <label for="date-range">To Date:</label>
                        </div>
                    </div>
                    <div class="filter-group custom-dropdown rx-status-dropdown">
                        <input type="checkbox" id="rx-status-dropdown-toggle" />
                        <label for="rx-status-dropdown-toggle" (click)="toggleRxStatusDropdown($event)" class="dropdown-button" id="rx-status" #rxStatus>{{ selRxStatusOption }}</label>
                        <ul id="rx-status" class="dropdown-menu" *ngIf="isRxStatusDropdownOpen" (click)="$event.stopPropagation()">
                            <li *ngFor="let option of rxStatusOptions" (click)="selectRxStatus(option, $event)">
                                {{ option }}
                            </li>
                        </ul>
                        <label for="rx-status">By Rx Status</label>
                    </div>
                    <div class="filter-buttons">
                        <button type="button" class="clear-button" (click)="closeFilter('reset')">Clear</button>
                        <button type="button" class="apply-button" (click)="getRxHistoryData('filter')">Apply</button>
                    </div>
                </div>
            </div>
            <div class="button-wrapper">
                <button class="buttonAdd_External_Meds" (click)="addExternalMeds()" >Add External Meds</button>
            </div>
         </div>
        <!--My Meds section End-->

        <!--Ready To Dispense section Start-->
        <div *ngSwitchCase="'readyToDispense'">
            <div class="ready-dispense mobile-common-scroll" #heightReadyDispense *ngIf="!noDataFound"> 
                <div class="title mobile-common-title">
                    <span>Total Dispense Count: {{dboardCounts.Ready_to_Dispense}}</span>
                    <span class="dispenseMenu"></span>
                </div>
                <div class="item mymeds" #item *ngFor="let item of readyForPickup; let i = index;" [class.active]="i === 0">
                    <div class="label" (click)="toggleAccordion(item, i)">
                        <div class="meds meds-1">
                            <span>Rx#</span>
                            <span>{{item?.RxDisplayNumber}}</span>
                        </div>
                        <div class="meds meds-2">
                            <span>Qty / Days Supply</span>
                            <span>{{item?.Qty}} / {{item?.Days_Supply}}</span>
                        </div>
                        <div class="meds meds-3">
                            <span>Drug Name</span>
                            <span>{{item?.Drug_Name | titlecase}}</span>
                        </div>
                        <div class="meds meds-4">
                            <span>Refills Left</span>
                            <span>{{item?.Refil_Left}}</span>
                        </div>
                        <div class="meds meds-5">
                            <span>Prescriber Name</span>
                            <span>{{item?.Prescriber_name | titlecase}}</span>
                        </div>
                        <div class="meds meds-6">
                            <span>Fill Date</span>
                            <span>{{item?.Fill_Date | dateTimeUtcPipe:'date'}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="noDataFound" class="nodataTxt">{{noData_Msg}}</div>
        </div>
        <!--Ready To Dispense section End-->

        <!--New Prescription section Start-->
        <div *ngSwitchCase="'newPrescription'">
            <div class="new-prescription mobile-common-scroll" #heightPrescription *ngIf="!noDataFound"> 
                <div class="title mobile-common-title">
                    <span>Total Prescriptions Count: {{newErxsCount}}</span>
                    <span class="dispenseMenu"></span>
                </div>
                <div class="item mymeds" #item *ngFor="let item of newPrescription;let i = index;" [class.active]="i === 0">
                    <div class="label" (click)="toggleAccordion(item, i)">
                        <div class="meds meds-1">
                            <span>Received Date</span>
                            <span>{{item?.Receieved_date | dateTimeUtcPipe:'date'}}</span>
                        </div>
                        <div class="meds meds-2">
                            <span>Qty / Days Supply</span>
                            <span>{{item?.Qty}} / {{item?.Days_Supply}}</span>
                        </div>
                        <div class="meds meds-3">
                            <span>Drug Name</span>
                            <span>{{item?.Drug_Name | titlecase}}</span>
                        </div>
                        <div class="meds meds-4">
                            <span>Prescriber Name</span>
                            <span>{{item?.Prescriber_name | titlecase}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="noDataFound" class="nodataTxt">{{noData_Msg}}</div>
        </div>
        <!--New Prescription section End-->

        <!--refillsDue section Start-->
        <div class="refillsDue-scroll" *ngSwitchCase="'refillsDue'">
            <div class="refills-due mobile-common-scroll" #heightRefillsDue *ngIf="!noDataFound"> 
                <div class="title mobile-common-title">
                    <span>Total Refills Due: {{refillsDueCount}}</span>
                    <span class="dispenseMenu"></span>
                </div>
                <div class="item mymeds" #item *ngFor="let item of refillsDueRxs; let i = index;" [class.active]="i === 0">
                    <div class="label" (click)="toggleAccordion(item, i)">
                        <div class="meds meds-1">
                            <span>Rx#</span>
                            <span>{{item?.RxNumber}}</span>
                        </div>
                        <div class="meds meds-2">
                            <span>Prescriber Name</span>
                            <span>{{item?.Prescriber_name | titlecase}}</span>
                        </div>
                        <div class="meds meds-3">
                            <span>Qty / Days Supply</span>
                            <span>{{item?.Qty}} / {{item?.Days_Supply}}</span>
                        </div>
                        <div class="meds meds-4">
                            <span>Refill Due Date</span>
                            <span>{{item?.Refil_Due_Date | dateTimeUtcPipe:'date'}}</span>
                        </div>
                        <div class="meds meds-5">
                            <span class="refillItems">Drug Name
                                <input type="checkbox" [(ngModel)]="item.checked" name="auth" value="{{item?.id}}"
                                [ngStyle]="{'display': (item?.status === 'Authorized') ? 'none' : 'inline-block'}">
                                <!--comment above line uncomment below line if both Deferred Or Authorized wnats to display-->
                                <!--<input type="checkbox" [(ngModel)]="item.checked" name="auth" value="{{item?.id}}"
                                [ngStyle]="{'display': (item?.status === 'Deferred' || item?.status === 'Authorized') ? 'none' : 'inline-block'}">-->
                            </span>
                            <span>{{item?.Drug_Name | titlecase}}</span>
                        </div>
                        <div class="meds meds-6">
                            <span>Refills Left</span>
                            <span>{{item?.Refil_Left}}</span>
                            <span class="authStatus" [ngClass]="{'greenClr': item?.status === 'Authorized'}">{{item?.status}}</span>
                            <!--comment above line uncomment below line if both Deferred Or Authorized wnats to display-->
                            <!--<span class="authStatus" [ngClass]="{'brownClr': item?.status === 'Deferred', 'greenClr': item?.status === 'Authorized'}">{{item?.status}}</span>-->
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="noDataFound" class="nodataTxt">{{noData_Msg}}</div>
            <div class="authSection" *ngIf="isAuthorized"> <button class="authBtn PhNum" (click)="authorizeAction()">Authorize</button></div>
        </div>
        <div class="externalMeds-backdrop" *ngIf="openExtenalMedsPopup || isEditExternalMeds || isTransferInMed || isDeleteExternalMeds || sendInitiationSuccess" ></div>
        <div class="externalMeds-modal" *ngIf="openExtenalMedsPopup || isEditExternalMeds || isTransferInMed">
            <div class="patientExternaMedsPopup" *ngIf="!isDeleteExternalMeds || !sendInitiationSuccess">
                <div class="externalMedsHeader">
                    <p>{{isEditExternalMeds ? 'Edit' : isTransferInMed ? 'Transfer Request' : 'Add'}} External Meds</p>
                    <button title="cancel" (click)="closeExternalMedsPopup(true)">×</button>
                </div>
                <div class="externalMeds_text" *ngIf="openExtenalMedsPopup">Add meds from other pharmacies for safer checks, and request a transfer if needed.</div>
                <div class="externalMeds_images" *ngIf="isTransferInMed">
                    <div class="externalMeds_text1" >Request a transfer to obtain your medication, Once processed, it will be available in your profile.</div>
                    <img alt="MyLogo" class="external_meds_logo" src="./assets/images/external meds.svg"/>
                </div>
                <form [formGroup]="externalRxFG" (ngSubmit)="addOrUpdateExternalMeds()">
                    <div class="externalMedsBody" >
                    <div class="extern_input1">
                      <app-mprx-input  label="Rx#" placeholder="Enter Rx#" formControlName="RxNumber" maxlength="12" [type]="'tel'"
                        [AllowOnlyNumbers]="true"></app-mprx-input>
                    </div>
                    <div class="extern_input2">
                      <app-mprx-input class="titlecase-input" label="Drug" placeholder="Search by either Name or NDC" [ShowSearchIcon]="true" [EnableSuggestions]="enableSuggestions" [IsRequired]="true" (loadMoreSuggestions)="onLoadMoreDrugSuggestions()" [hasMoreData]="hasMoreDrugSuggestions" [TotalDrugCount]="totalDrugCount"
                      [FilteredData]="filterData" (input)="onSearch($event,'DrugName')" formControlName="DrugName" (getSelectedInfo)="getSelectedInformation($event,'drugName')" [fieldName]="'DrugName'" [IsDrugNotFound]="isDrugNotFound">
                      <!-- (keydown)="onKeyDown($event,'Drug_Name')" -->
                    </app-mprx-input>
                    </div>
                    <div class="extern_input3">
                      <app-mprx-input  label="Refills Left" placeholder="Enter Refills" formControlName="RefillsLeft" maxlength="10"></app-mprx-input>
                    </div>
                    <div class="extern_input4">
                      <app-mprx-date-picker  label="Ordered Date" placeholder="MM/DD/YYYY" formControlName="OrderDate" (valueChange)="onDateChanged($event)"></app-mprx-date-picker>
                    </div>
                    <div class="extern_input5">
                      <app-mprx-date-picker  label="Fill Date" formControlName="FillDate" placeholder="MM/DD/YYYY" (valueChange)="onDateChanged($event)" [IsRequired]="true" [IsFillDtExdedThanOrderDt]="isFillDtExceeded"></app-mprx-date-picker>
                    </div>
                    <div class="extern_input6">
                      <app-mprx-date-picker  label="Expiration Date" placeholder="MM/DD/YYYY" (valueChange)="onDateChanged($event)" formControlName="ExpirationDate" [minDate]="orderDate"></app-mprx-date-picker>
                    </div>
                    <div class="extern_input7">
                      <app-mprx-input  label="Days Supply" placeholder="Enter Days Supply" formControlName="SupplyDays"></app-mprx-input>
                    </div>
                    <div class="extern_input11">
                        <app-mprx-input label="Qty Dispensed" placeholder="Enter Qty Dispensed" formControlName="QtyDisp"></app-mprx-input>
                    </div>
                    <div class="extern_input8">
                        <app-mprx-input class="titlecase-input" label="Dispensing Pharmacy" placeholder="Search by Pharmacy Name" [ShowSearchIcon]="true" [IsRequired]="true" [EnableSuggestions]="enableSuggestions" [IsRequired]="true" [IsPharmacyNotFound]="isPharmacyNotFound" 
                     (blurEvent)="onInputFocusOut($event)"
                        [FilteredData]="filterData" (input)="onSearch($event,'DispensingPharmacy')" formControlName="DispensingPharmacy" [fieldName]="'DispensingPharmacy'" (getSelectedInfo)="getSelectedInformation($event,'dispensingPharmacy')"></app-mprx-input>
                    </div>
                    <div class="extern_input9">
                        <app-mprx-input  label="Pharmacy Phone#" placeholder="Enter Phone#" maxlength="10" [IsRequired]="true" formControlName="PharmacyPhone" [type]="'tel'" [phoneNumExists]= "this.externalRxFG.controls['PharmacyPhone'].value ? true : false"
                            [AllowOnlyNumbers]="true" [UsePhoneFormat]="true"></app-mprx-input>
                    </div>
                    <div class="extern_input10">
                        <app-mprx-input  label="Notes" placeholder="Enter Notes" formControlName="ExternNotes"></app-mprx-input>
                    </div>
                
                
                </div>
                
                <div class="common_buttons_footer">
                    <button type="button" class="common_buttons" (click)="closeExternalMedsPopup(true)">Cancel</button>
                    <button type="submit" class="common_buttons" [disabled]="!(externalRxFG.controls['DrugName'].value && externalRxFG.controls['DispensingPharmacy'].value && externalRxFG.controls['PharmacyPhone'].value && externalRxFG.controls['FillDate'].value && (drugNDC || isTransferInMed || isEditExternalMeds))" [ngClass]="{
                        'input_disabled': !(externalRxFG.controls['DrugName'].value && externalRxFG.controls['DispensingPharmacy'].value && externalRxFG.controls['PharmacyPhone'].value && externalRxFG.controls['FillDate'].value && (drugNDC || isTransferInMed || isEditExternalMeds))
                        }">{{isEditExternalMeds ? 'Update' : isTransferInMed ? 'Send Request' : 'Save'}}</button>
                </div>
                </form>
            </div>
            
        </div>
         <div class="dup-error-backdrop" *ngIf="showDuplicateError"></div>
        <div class="dup-error-popup" *ngIf="showDuplicateError">
            <button class="dup-close" (click)="showDuplicateError = false">×</button>
            <div class="dup-body">
                <span class="material-symbols-outlined dup-icon">error</span>
                <span class="dup-msg">A Prescription with the same Rx number and pharmacy already exists.</span>
            </div>
        </div>
        <div class="externalMedsDeletePopup" *ngIf="isDeleteExternalMeds || sendInitiationSuccess">
            <div class="externalMedsHeader">
                    <button title="cancel" class="delete_cross" (click)="closeExternalMedsPopup(true)">×</button>
                </div>
            <div class="delete_Header"><img alt="MyLogo" class="external_delete_logo" [src]="isDeleteExternalMeds ? './assets/images/delete extern.svg' : './assets/images/sent success.svg'" /></div>
            <div class="delete_Main">
                    <div class="colur_Bright_Violet font_weight_500 padding_bottom_15px">{{isDeleteExternalMeds ? 'Delete External Rx?' : 'Sent Request Successfully!'}}</div>
                <div class="delete_Text padding_bottom_15px"
                    [innerHTML]="isDeleteExternalMeds ? 'Are you sure you want to delete the external rx with the drug <b>' + drugName + '</b>?'
                    : 'Thanks for choosing us! After processing, your prescription will be visible in your history'">
                </div>
            </div>
            <div class="common_buttons_footer" *ngIf="isDeleteExternalMeds">
                <button type="button" class="common_buttons" (click)="closeExternalMedsPopup(true)">Cancel</button>
                <button type="submit" class="common_buttons" (click)="confirmToDeleteExternalMeds()">Delete</button>
           </div>
            <div class="sent_success_button" *ngIf="sendInitiationSuccess">
                <button type="button" class="common_buttons" (click)="closeExternalMedsPopup()">Ok</button>
            </div>
        </div>
        <!--refillsDue section End-->
    </div>
</div>
<my-footer></my-footer>
